/**
 * Compact 4-line skeleton used while the durable transcript loads.
 * Light enough that flashing it for sub-300ms loads is not jarring.
 */
export const ProjectChatSkeleton = () => (
  <div className="mx-auto flex w-full max-w-3xl flex-col gap-4 py-6">
    <div className="h-4 w-24 animate-pulse rounded bg-background-tertiary" />
    <div className="h-16 animate-pulse rounded-lg bg-background-tertiary" />
    <div className="h-4 w-32 animate-pulse rounded bg-background-tertiary" />
    <div className="h-24 animate-pulse rounded-lg bg-background-tertiary" />
  </div>
);
